import React, { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import { Modal } from "medere-ui-framework";

type ConsentWindowProps = {
    showConsentWindow: boolean;
    setShowConsentWindow: (open: boolean) => void;
    consentHtml: string;
    onAccept: () => void;
};

export default function ConsentWindow ({showConsentWindow, setShowConsentWindow, consentHtml, onAccept }:ConsentWindowProps) {
    return (
        <Modal
            maximized
            visible={showConsentWindow}
            setVisible={setShowConsentWindow}
            header={<h6 className="modalTitle">{"Consentimiento de usuario"}</h6>}
            headerStyle={{ background: "#f3f5f7" }}
            footerButtonRightText = {"Acepto el consentimiento"}
            onClickRightBtn={()=>{
                onAccept();
            }}
            closable={false}
        >
            <div className="consent-content" dangerouslySetInnerHTML={{ __html: consentHtml }} />
        </Modal>
    );
};
